import { useEffect } from "react";

let isFirstTime = true;
let timeout: number | null = null;

export const useFirstTimeLoad = (delay: number = 300) => {
    useEffect(() => {
        if (!isFirstTime) return;
        if (timeout) {
            window.clearTimeout(timeout);
            timeout = null;
        }
        return () => {
            if (isFirstTime) {
                window.clearTimeout(timeout);
                timeout = window.setTimeout(() => {
                    isFirstTime = false;
                }, delay);
            }
        };
    }, []);
    return isFirstTime;
};
